/**
 * @fileoverview modifyUserInfo.js 账号安全=>修改信息 路由配置文件
 */
export default [
  {
    path: '/modify',
    name: 'modify',
    component: () => import('@/view/mine/modify/index.vue')
  },
  {
    path: '/modify/base',
    name: 'modifyBase',
    component: () => import('@/view/mine/modify/base.vue')
  },
  {
    path: '/modify/additional',
    name: 'modifyAdditional',
    component: () => import('@/view/mine/modify/additional.vue')
  },
  {
    path: '/modify/addId',
    name: 'modifyAddId',
    component: () => import('@/view/mine/modify/addId.vue')
  },
  {
    path: '/modify/addOther',
    name: 'modifyAddOther',
    component: () => import('@/view/mine/modify/addOther.vue')
  },
  {
    path: '/modify/result',
    name: 'modifyResult',
    component: () => import('@/view/mine/modify/result.vue')
  },
  {
    path: '/modify/protocol',
    name: 'modifyProtocol',
    component: () => import('@/view/mine/modify/protocol.vue')
  }
]

